document.addEventListener('DOMContentLoaded', function () {
  // 全ページ共通の機能
  setupHamburgerMenu();
  setupScrollFadeIn();
  setupScrollTopButton();
  // 現在（ドメイン以降の）のパスを取得
  const path = window.location.pathname;

  // トップページ専用の機能
  if (path === '/' || path.match(/^\/index.html$/)) {
    setupMvscroll();
    setupLocationsCarousel();
    setupStoryHistoryScroll();
    setupRelatedModals();
    // 初回判定用のフラグを取得
    const isFirstLoad = sessionStorage.getItem('isFirstLoad');
    if (!isFirstLoad) {
      // 初回アクセス時の処理
      // firstTimeTopPageFunctions(); //仮の関数
      // フラグを保存
      sessionStorage.setItem('isFirstLoad', true);
    } else {
      // 2回目以降のアクセス時の処理
      // repeatedTopPageFunctions(); //仮の関数
    }
  } else {
    // 下層ページ共通の機能（必要に応じて記述）

    // 導入先一覧専用の機能
    if (path.match(/^\/locations(\/|$)/)) {
      archiveLocationsTabSwitch();
      // 会社概要ページ専用の機能
    } else if (path.match(/^\/interview(\/|$)/)) {
      setupInterviewSlide();
      // お知らせ一覧ページ専用の機能
    } else if (path.match(/^\/news(\/|$)/)) {
      scrollToHashOnLoad();
      archiveNewsTabSwitch();
      // お問い合わせページ専用の機能
    } else if (path.match(/^\/contact(\/|$)/)) {
      contactFormSelectValidate();
    }
  }
});

// ハンバーガーボタン・ドロワーメニュー開閉制御
function setupHamburgerMenu() {
  const menu = document.querySelector('.js-header__menu');
  const drawer = document.querySelector('.js-header__drawer');
  const menuText = document.querySelector('.p-header__menu-text-uppercase');
  const menuTextOpen = menuText.querySelector('[data-text="menu"]');
  const menuTextClose = menuText.querySelector('[data-text="close"]');

  if (!menu || !drawer || !menuText || !menuTextOpen || !menuTextClose) return;

  menu.addEventListener('click', () => {
    const expanded = menu.getAttribute('aria-expanded') === 'true';

    // メニューの状態を更新
    menu.classList.toggle('active');
    menu.setAttribute('aria-expanded', !expanded);

    // テキストの切り替え
    menuTextOpen.classList.toggle('active');
    menuTextClose.classList.toggle('active');

    // ドロワーの状態を更新
    drawer.classList.toggle('active');
    drawer.setAttribute('aria-hidden', expanded);

    // ドロワーがアクティブな時はスクロールを防止
    document.body.style.overflow = drawer.classList.contains('active') ? 'hidden' : 'auto';
  });

  // ドロワー内のリンククリック時の処理
  drawer.querySelectorAll('.drawer__link').forEach(link => {
    link.addEventListener('click', () => {
      menu.classList.remove('active');
      menu.setAttribute('aria-expanded', 'false');

      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');

      // ドロワーが閉じたらスクロールを再び有効化
      document.body.style.overflow = 'auto';
    });
  });
}

// スクロールトップボタンのスムーズスクロール制御
function setupScrollTopButton() {
  const scrollTopButton = document.querySelector('.p-footer__scroll-top');
  if (!scrollTopButton) return;

  scrollTopButton.addEventListener('click', e => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

// トップページメインビジュアルのスライドとテキストの無限スクロール
function setupMvscroll() {
  const upperLists = document.querySelector('.p-mv__upper-slide-lists');
  const lowerLists = document.querySelector('.p-mv__lower-slide-lists');
  const scrollText = document.querySelector('.p-mv__scroll-text');

  if (!upperLists || !lowerLists) return;

  // スライドの複製と追加
  const setupInfiniteScroll = (container, isText = false) => {
    if (!container) return;

    if (isText) {
      const textContent = container.textContent;
      const requiredSets = 7;

      // 最初のテキストはそのまま
      container.textContent = textContent + ' ';

      // 2個目以降の複製にaria-hiddenを付与
      for (let i = 0; i < requiredSets - 1; i++) {
        const clone = document.createElement('span');
        clone.textContent = textContent + ' ';
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
      }
      return;
    }

    // 背景画像スライドの複製（aria-hidden不要）
    const slides = Array.from(container.children);
    const requiredSets = 7;

    for (let i = 0; i < requiredSets - 1; i++) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        container.appendChild(clone);
      });
    }
  };

  // 上下のスライドとスクロールテキストを初期化
  setupInfiniteScroll(upperLists);
  setupInfiniteScroll(lowerLists);
  setupInfiniteScroll(scrollText, true);

  // アニメーションの適用（60秒）
  upperLists.style.animation = 'mvUpperSlideListsScroll 60s linear infinite';
  lowerLists.style.animation = 'mvLowerSlideListsScroll 60s linear infinite';
  if (scrollText) {
    scrollText.style.animation = 'mvUpperSlideListsScroll 60s linear infinite';
  }
}

// トップページの店舗種類一覧のスライド
function setupLocationsCarousel() {
  try {
    // splideOptionsが未定義の場合、デフォルトのオプションを設定
    const defaultSplideOptions = {
      type: 'loop',
      autoplay: false, // autoplayを無効化
      interval: 2000, // スピードを少し早く
      arrows: false, // splide__arrowを無効化
      autoWidth: true, // CSSで幅を指定するためにautoWidthを有効化
      drag: false, // ドラッグでのスライドを無効化
      pagination: false, // ページネーションを無効化
      autoScroll: {
        autoStart: true, // 自動スクロールを無効化
        pauseOnHover: false, // ホバー時に一時停止しない
        pauseOnFocus: false, // フォーカス時に一時停止しない
        pauseOnDrag: false, // ドラッグ時に一時停止しない
        speed: 1 // 自動スクロールの速度を設定
      },
      breakpoints: {
        767: {
          perPage: 1.5, // 767px以下では1.5枚表示
          focus: 'center' // 中央にセット
        }
      }
    };

    const options = typeof splideOptions !== 'undefined' ? splideOptions : defaultSplideOptions;

    const splide = new Splide('#locations-carousel', options);
    splide.mount(window.splide.Extensions);
  } catch (error) {
    console.error('Locationsカルーセルの設定中にエラーが発生しました:', error);
  }
}

// 導入先一覧のタブ切り替え・店舗表示切り替え
function archiveLocationsTabSwitch() {
  const tabs = document.querySelectorAll('.p-locations-archive__tab-list');
  const categories = document.querySelectorAll('.p-locations-archive__category');

  // 「店舗が見つかりません」メッセージ要素を作成する関数
  const createNoPostsMessage = () => {
    const message = document.createElement('p');
    message.className = 'p-locations-archive__no-posts';
    message.textContent = 'このカテゴリーの店舗は現在見つかりませんでした。';
    return message;
  };

  // アニメーション要素の表示を制御する関数
  const showAnimatedElements = category => {
    const titles = category.querySelectorAll('.p-locations-archive__prefecture-title');
    const storeItems = category.querySelectorAll('.p-locations-archive__store-list-inner');

    // 店舗が見つからない場合のメッセージ表示
    if (titles.length === 0 && storeItems.length === 0) {
      // 既存のメッセージを削除
      const existingMessage = category.querySelector('.p-locations-archive__no-posts');
      if (existingMessage) {
        existingMessage.remove();
      }

      // 新しいメッセージを追加
      const noPostsMessage = createNoPostsMessage();
      category.appendChild(noPostsMessage);

      setTimeout(() => {
        noPostsMessage.classList.add('is-visible');
      }, 0);
      return;
    }

    // タイトルのアニメーション
    titles.forEach((title, index) => {
      setTimeout(() => {
        title.classList.add('is-visible');
      }, index * 100);
    });

    // 店舗リストのアニメーション
    storeItems.forEach((item, index) => {
      setTimeout(
        () => {
          item.classList.add('is-visible');
        },
        titles.length * 100 + index * 100
      );
    });
  };

  // タブ切り替えの処理
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const selectedCategory = this.getAttribute('data-category');

      // タブの状態を更新
      tabs.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');

      // 現在のカテゴリーをリセット
      categories.forEach(category => {
        const noPostsMessage = category.querySelector('.p-locations-archive__no-posts');
        if (noPostsMessage) {
          noPostsMessage.classList.add('is-hiding');
          setTimeout(() => {
            noPostsMessage.remove();
          }, 500);
        }
        category.querySelectorAll('.p-locations-archive__prefecture-title, .p-locations-archive__store-list-inner').forEach(element => {
          element.classList.remove('is-visible');
        });
        category.style.display = 'none';
      });

      // 選択されたカテゴリーを表示
      const targetCategory = document.querySelector(`.p-locations-archive__category[data-category="${selectedCategory}"]`);
      if (targetCategory) {
        targetCategory.style.display = 'grid';
        showAnimatedElements(targetCategory);
      }
    });
  });

  // 初期表示時の設定（アニメーションあり）
  const activeTab = document.querySelector('.p-locations-archive__tab-list.is-active');
  if (activeTab) {
    const initialCategory = activeTab.getAttribute('data-category');
    categories.forEach(category => {
      if (category.getAttribute('data-category') === initialCategory) {
        category.style.display = 'grid';
        showAnimatedElements(category);
      } else {
        category.style.display = 'none';
      }
    });
  }
}

// 下層ページのインタビュースライド制御
function setupInterviewSlide() {
  const splideOptions = {
    autoplay: false,
    perPage: 1,
    direction: 'ttb',
    arrows: false,
    wheel: true,
    pagination: false,
    height: '100vh',
    perMove: 1,
    wheelMinThreshold: 1,
    wheelSleep: 100,
    waitForTransition: true,
    releaseWheel: true,
    speed: 1000,
    easing: 'ease-in-out',
    threshold: 100,
    intersection: {
      inView: true,
      threshold: 1.0
    }
  };

  const mql = window.matchMedia('(min-width: 768px)');
  const pcSlideElement = document.querySelector('.p-interview-slide__splide--pc');
  const spSlideElement = document.querySelector('.p-interview-slide__splide--sp');

  let pcSplide = null;
  let spSplide = null;

  const initializeSlider = e => {
    if (e.matches) {
      // PC表示の場合
      if (pcSlideElement) {
        pcSlideElement.removeAttribute('aria-hidden');
        pcSlideElement.removeAttribute('inert');
      }
      if (spSlideElement) {
        spSlideElement.setAttribute('aria-hidden', 'true');
        spSlideElement.setAttribute('inert', '');
      }
      if (pcSlideElement && !pcSplide) {
        pcSplide = new Splide('.p-interview-slide__splide--pc', splideOptions);
        pcSplide.mount();
      }
      if (spSplide) {
        spSplide.destroy();
        spSplide = null;
      }
    } else {
      // SP表示の場合
      if (spSlideElement) {
        spSlideElement.removeAttribute('aria-hidden');
        spSlideElement.removeAttribute('inert');
      }
      if (pcSlideElement) {
        pcSlideElement.setAttribute('aria-hidden', 'true');
        pcSlideElement.setAttribute('inert', '');
      }
      if (spSlideElement && !spSplide) {
        spSplide = new Splide('.p-interview-slide__splide--sp', splideOptions);
        spSplide.mount();
      }
      if (pcSplide) {
        pcSplide.destroy();
        pcSplide = null;
      }
    }
  };

  // 初期化時に実行
  initializeSlider(mql);

  // ブレイクポイントの変更時に実行
  mql.addListener(initializeSlider);
}

// お知らせ一覧のタブ切り替え
function archiveNewsTabSwitch() {
  const tabButtons = document.querySelectorAll('.p-archive-news-articles__tab-list');
  const newsContainer = document.querySelector('.p-archive-news-articles__lists');
  let currentPage = 3;
  let isLoading = false;
  let selectedCategory = 'all';
  let currentIndex = 10;

  // ローディング要素を作成
  const loadingElement = document.createElement('div');
  loadingElement.className = 'p-archive-news-articles__loading';
  loadingElement.innerHTML = '<div class="p-archive-news-articles__loading-spinner"></div>';
  document.querySelector('.p-archive-news-articles__content').appendChild(loadingElement);

  const loadMorePosts = async () => {
    if (isLoading) return;
    isLoading = true;

    try {
      loadingElement.classList.add('is-active');
      await new Promise(resolve => setTimeout(resolve, 800));

      const response = await fetch(`/wp-admin/admin-ajax.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `action=load_more_news&page=${currentPage}&category=${selectedCategory}`
      });

      const data = await response.json();

      if (data.success && data.posts.length > 0) {
        data.posts.forEach((post, index) => {
          currentIndex++;
          const li = document.createElement('li');
          li.className = 'p-archive-news-articles__list c-articles-lists__list p-archive-news-articles__list--loading';
          li.dataset.category = post.category_slug;
          if (currentPage === 1) {
            li.dataset.index = currentIndex;
          }
          li.innerHTML = `
            <a href="${post.permalink}" class="p-archive-news-articles__link c-articles-list__link">
              <div class="p-archive-news-articles__date-and-category c-articles-list__detail-and-category">
                <p class="p-archive-news-articles__date c-articles-list__date">${post.date}</p>
                <p class="p-archive-news-articles__category c-articles-list__category">${post.category_name}</p>
              </div>
              <p class="p-archive-news-articles__title c-articles-list__title">${post.title}</p>
            </a>
          `;
          newsContainer.appendChild(li);

          // 追加読み込み時は遅延を付けてアニメーション
          if (currentPage > 1) {
            setTimeout(() => {
              li.classList.add('is-visible');
            }, index * 100);
          }
        });

        currentPage++;

        // 新しく追加された要素に対して監視を設定
        const newItems = newsContainer.querySelectorAll('.p-archive-news-articles__list:not([data-observed])');
        newItems.forEach(item => {
          observer.observe(item);
          item.dataset.observed = 'true';
        });

        if (!data.has_more) {
          const lastItem = newsContainer.querySelector('.p-archive-news-articles__list:last-child');
          if (lastItem) {
            observer.unobserve(lastItem);
          }
        }
      }
    } catch (error) {
      console.error('記事の読み込みに失敗しました:', error);
    } finally {
      loadingElement.classList.remove('is-active');
      isLoading = false;
    }
  };

  // タブ切り替えの処理
  tabButtons.forEach(button => {
    button.addEventListener('click', async function () {
      if (isLoading) return;

      tabButtons.forEach(btn => btn.classList.remove('is-active'));
      this.classList.add('is-active');

      selectedCategory = this.dataset.category;
      currentPage = 1;
      currentIndex = 0;

      newsContainer.innerHTML = '';

      await loadMorePosts();
    });
  });

  // Intersection Observerの設定
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('fade-in')) {
          // 最後の要素が表示されたら次の記事を読み込む
          const allItems = document.querySelectorAll('.p-archive-news-articles__list');
          if (entry.target === allItems[allItems.length - 1]) {
            loadMorePosts();
          }
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    }
  );

  // 初期表示の要素に対して監視を設定
  document.querySelectorAll('.p-archive-news-articles__list').forEach(item => {
    observer.observe(item);
    item.dataset.observed = 'true';
  });
}

// トップページstoryセクションのスクロール制御
function setupStoryHistoryScroll() {
  const historyLists = document.querySelector('.p-story__history-text-lists');
  if (!historyLists) return;

  let isScrollingHistory = false;
  const scrollMultiplier = 1.2;

  // Intersection Observerの設定
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.9) {
          isScrollingHistory = true;
        } else {
          isScrollingHistory = false;
        }
      });
    },
    {
      threshold: [0, 0.5, 0.9, 1.0]
    }
  );

  observer.observe(historyLists);

  // ホイールイベントの制御
  window.addEventListener(
    'wheel',
    e => {
      if (isScrollingHistory) {
        const scrollAmount = e.deltaY * scrollMultiplier;
        const currentScroll = Math.round(historyLists.scrollTop);
        const maxScroll = Math.round(historyLists.scrollHeight - historyLists.clientHeight);
        const isNearBottom = currentScroll + 1 >= maxScroll;
        const isNearTop = currentScroll <= 1;

        // 最下部で下方向へのスクロール、または最上部で上方向へのスクロールの場合
        if ((isNearBottom && scrollAmount > 0) || (isNearTop && scrollAmount < 0)) {
          isScrollingHistory = false;
          return;
        }

        // それ以外の場合はリスト内でスクロール
        e.preventDefault();
        const newScrollTop = Math.max(0, Math.min(currentScroll + scrollAmount, maxScroll));
        historyLists.scrollTop = newScrollTop;
      }
    },
    { passive: false }
  );
}

// トップページrelatedセクションのモーダル制御
function setupRelatedModals() {
  const modalTriggers = document.querySelectorAll('.js-modal-trigger');
  const modalsContainer = document.querySelector('.p-related__modals');
  const modals = document.querySelectorAll('.p-related__modal');

  if (!modalTriggers.length || !modalsContainer || !modals.length) return;

  // 初期状態ですべてのモーダルを非表示に
  modals.forEach(modal => {
    modal.style.display = 'none';
  });

  // モーダルを開く処理
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const modalId = trigger.getAttribute('data-modal');
      const targetModal = document.getElementById(modalId);

      if (targetModal) {
        modalsContainer.classList.add('is-active');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          targetModal.style.display = 'grid';
          setTimeout(() => {
            targetModal.classList.add('is-active');
          }, 50);
        }, 200);
      }
    });
  });

  // モーダルを閉じる処理
  const closeButtons = document.querySelectorAll('.p-related__modal-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', closeModal);
  });

  // 背景クリックでモーダルを閉じる
  modalsContainer.addEventListener('click', e => {
    if (e.target === modalsContainer) {
      closeModal();
    }
  });

  // ESCキーでモーダルを閉じる
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  function closeModal() {
    const activeModal = document.querySelector('.p-related__modal.is-active');
    if (activeModal) {
      activeModal.classList.remove('is-active');
      setTimeout(() => {
        activeModal.style.display = 'none';
        modalsContainer.classList.remove('is-active');
        document.body.style.overflow = 'auto';
      }, 400);
    }
  }
}

// 共通コンポーネントのスクロールフェードイン実装
function setupScrollFadeIn() {
  const fadeElements = document.querySelectorAll('.c-scroll-fadein');

  fadeElements.forEach(element => {
    ScrollTrigger.create({
      trigger: element,
      start: 'top 80%', // 画面の下から20%の位置でトリガー
      once: true, // 1回だけ実行
      onEnter: () => {
        element.classList.add('is-active');
      }
    });
  });
}
